import React, { useState } from 'react';
import { auth } from './firebase';
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
// import { useNavigate } from 'react-router-dom'; // Not needed
import { generateUsername } from './utils/usernameGenerator';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  // const navigate = useNavigate(); // Not needed since we use window.location.href
  const [anonymousUsername, setAnonymousUsername] = useState(generateUsername());

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      // Update profile with anonymous username
      await updateProfile(user, {
        displayName: anonymousUsername
      });

      // Get fresh token
      const token = await user.getIdToken(true); // Force refresh token
      localStorage.setItem('userToken', token);
      localStorage.setItem('userId', user.uid);

      // Store in database
      const response = await fetch(`${process.env.REACT_APP_API_URL}/create-user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` // Add token to request
        },
        body: JSON.stringify({
          uid: user.uid,
          email: user.email,
          username: anonymousUsername
        })
      });

      if (!response.ok) {
        throw new Error('Failed to create user in database');
      }

      const userData = await response.json();
      console.log('User created successfully:', userData);

      // Redirect to ShowingBooker for property management users
      window.location.href = '/showingbooker';
    } catch (error) {
      console.error('Registration error:', error);
      setError(error.message);
    }
  };

  const regenerateUsername = () => {
    setAnonymousUsername(generateUsername());
  };

  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <h2>Register</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleRegister}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{ padding: '10px', marginBottom: '10px', width: '250px' }}
        />
        <br />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{ padding: '10px', marginBottom: '10px', width: '250px' }}
        />
        <br />
        <div style={{ marginBottom: '15px' }}>
          <label>Your Anonymous Username:</label>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', alignItems: 'center' }}>
            <input
              type="text"
              value={anonymousUsername}
              readOnly
              style={{ 
                padding: '10px',
                width: '200px',
                backgroundColor: '#f0f0f0'
              }}
            />
            <button
              type="button"
              onClick={regenerateUsername}
              style={{
                padding: '10px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              ↻ New Name
            </button>
          </div>
        </div>
        
        <div style={{ 
          background: '#e7f3ff', 
          border: '1px solid #b3d9ff', 
          borderRadius: '6px', 
          padding: '12px', 
          margin: '16px 0',
          fontSize: '13px',
          lineHeight: '1.4'
        }}>
          <strong>📱 Communication Notice:</strong> By registering, you agree to receive SMS and email 
          notifications essential to ShowingBooker services. This includes booking confirmations, 
          appointment reminders, and coordination messages. See our{' '}
          <a href="/showingbooker/terms" style={{ color: '#007AFF' }}>Terms of Service</a> for details.
        </div>
        
        <button type="submit" style={{ padding: '10px 20px' }}>Register</button>
      </form>
      <p>Already have an account? <a href="/login">Login here</a></p>
    </div>
  );
};

export default Register;
